/// <reference types="google.maps" />
import { Component, Input, Output, EventEmitter, NgZone, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { faMapPin, faCheck, faExclamationTriangle, faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons';
import { EnvironmentConfig } from '@clooper/core';
import { Loader } from '@googlemaps/js-api-loader';
import * as uuid from 'uuid';

@Component({
  selector: 'app-location-selector',
  templateUrl: './location-selector.component.html',
  styleUrls: ['./location-selector.component.scss']
})
export class LocationSelectorComponent implements AfterViewInit {

  icons = {
    marker: faMapMarkerAlt,
    pin: faMapPin,
    check: faCheck,
    error: faExclamationTriangle,
  }

  id = 'i' + uuid.v4();

  @Input() value: string;
  @Input() disabled: boolean;
  @Input() required: boolean;
  @Input() formCtrlName: string;
  @Input() formGrp: FormGroup;
  @Input() showErrorMsg = true;
  @Input() showExample = true;
  @Input() showPrefixIcon = true
  @Input() showPrefixPadding = true
  @Input() className = '';
  @Input() placeholder = 'Enter address'
  @Output() values = new EventEmitter();
  @Output() inputValue = new EventEmitter();


  private loader: any;

  error_msg: string;

  constructor(
    private ngZone: NgZone,
    private config: EnvironmentConfig,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.loader = new Loader({
      apiKey: this.config.google_api_key as string,
      libraries: ['places'],
      version: 'weekly',
      //region: 'GB'
    });
  }

  ngAfterViewInit() {
    this.loader.load().then(() => {
      // const options = {
      // componentRestrictions: { country: 'uk' }
      // }
      const autocomplete = new google.maps.places.Autocomplete(
        this.document.getElementById(this.id) as HTMLInputElement,
        {
          // types: ["(cities)"],
        }
        
        // options
      );
      autocomplete.addListener('place_changed', () => this.ngZone.run((): void => {
        this.error_msg = '';
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          this.error_msg = 'No result';
        } else {
          const address = this.getAddress(place.address_components)
          this.setFormValue(place.formatted_address || '')
          const { lat, lng } = (place.geometry.location as any);
          const latlng = [lat(), lng()]
          const s = place.formatted_address
          this.values.emit({ address, latlng, s, place });
        }
      }))
    })
  }

  get formCtrl(): any {
    return this.formGrp.get(this.formCtrlName)
  }

  private getAddress(address_components: any) {
    const {
      premise, street_number, route,
      administrative_area_level_2,
      postal_town, administrative_area_level_1, country,
      postal_code, postal_code_prefix
    } = this.getAddressComponents(address_components);
    const input: any = this.value;
    const house_no_match = /^(\d{1,})/.exec(input);
    const house_no = house_no_match ? house_no_match[1] : '';
    const address: any = {
      house_no: street_number?.long_name || premise?.long_name || house_no || '',
      street: route?.long_name || '',
      city: administrative_area_level_2?.long_name || '',
      town: postal_town?.long_name || '',
      state: administrative_area_level_1?.long_name || '',
      country: country?.long_name || '',
      postcode: postal_code?.long_name || postal_code_prefix?.long_name || ''
    };
    let missing = ['street', 'postcode', 'country'].find(key => {
      return address[key] === ''
    });
    // if (missing) {
    //   if (missing === 'house_no') {
    //     missing = 'house number or '
    //   }
    //   this.error_msg = `Please add ${missing} name`
    // }
    return address;
  }

  private getAddressComponents(address: any[]) {
    return address.reduce((result, addr) => {
      const type = addr.types[0]
      result[type] = addr
      return result
    }, {})
  }

  private setFormValue(value: string) {
    if (this.formCtrlName && this.formGrp) {
      this.formGrp.get(this.formCtrlName)?.setValue(value)
    }
  }

  resetInput() {
    this.values.emit({ latlng: undefined, address: undefined });
  }
  getInputValue() {
    this.inputValue.emit({ value: this.value })
  }

}
